import { Anchor, Text } from '@zillow/constellation';

import type { PartialMessageProps } from '../../model/PartialMessage';

type Props = {
  partialMessages: Array<PartialMessageProps>;
  fontType?: 'body' | 'bodySmall' | 'finePrint';
  linkComponent?: typeof Anchor;
  onUrlClick?: (e: React.MouseEvent<HTMLAnchorElement>, url: string, text: string) => void;
  eventId?: string;
};

export const PartialMessage = ({
  partialMessages = [],
  fontType = 'body',
  linkComponent: LinkComponent = Anchor,
  onUrlClick,
  eventId,
}: Props) => {
  return (
    <div data-testid="PartialMessage">
      {partialMessages.map(({ url, text, isBold }, i) => (
        <Text key={`partial-message-${text}`} fontType={isBold ? `${fontType}Heading` : fontType}>
          {url ? (
            <LinkComponent
              key={i}
              href={url}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => onUrlClick?.(e, url, text)}
              target="_blank"
              data-eventid={eventId}
            >
              {`${text}`}
            </LinkComponent>
          ) : (
            `${text}`
          )}
        </Text>
      ))}
    </div>
  );
};
